export const live = {
  title: "ライブ",
  // おねだりゲームの概要説明（消費ptゲージ 1a / プレゼントCHANCE 2a で共通利用）
  onedariGameDescription:
    "配信中におねだりを送ってプレゼントを解禁しよう！\n配信中に使われたポイントに応じて、プレゼントが段階的にオープン！\n使ったポイントが多いほど応募口数が増えて、当選チャンスアップ！",
  listTitle: "配信",
  trending: "急上昇",
  free: "無料",
  freeWatching: "無料視聴中",
  live: "LIVE",
  // BottomNav の無料視聴対象配信バッジ用
  limitedLive: "限定LIVE",
  limitedLiveAppear: (args: { name: string | number }) => `${args.name}登場！`,
  // BottomNav のお気に入りユーザー配信中バッジ用（タブラベルは「配信」のまま変えない）
  favoriteBroadcastLive: "お気に入りの女性が配信中",
  // ライブ一覧カードのお気に入り強調バッジ用
  favoriteBadge: "お気に入り",
  standby: "待機中",
  viewerCount: (args: { count: string | number }) => `${args.count}人視聴中`,
  pastBroadcastNotice: "※再生されている映像は過去の配信映像です。",
  pointPerMinute: (args: { point: string | number }) => `${args.point}pt/分`,
  noChannels: "ライブ配信中のチャンネルはありません",
  leave: "終了",
  remainingPoint: (args: { point: string | number }) => `残り ${args.point}pt`,
  chatPlaceholder: "メッセージ",
  // 配信入室時に自動送信する挨拶メッセージ（本家 Utage 同様）
  autoGreeting: "こんにちは",
  toyMenu: "Toyメニュー",
  toyPointCost: (args: { point: string | number }) => `${args.point}pt`,
  durationSeconds: (args: { duration: string | number }) =>
    `${args.duration}秒`,
  purchase: "購入",
  remoteVibe: "遠隔バイブ",
  remoteVibeMenuTitle: "遠隔バイブメニュー",
  openRemoteVibeMenu: "遠隔バイブメニューを開く",
  onedari: "おねだり",
  onedariTitle: "おねだりメニュー",
  // 最新メッセージへ移動ボタン（cap到達後の自動追従停止時のみ表示）の a11y ラベル
  jumpToLatest: "最新のメッセージへ移動",
  lovenseSentMessage: (args: { name: string | number }) =>
    `「${args.name}」のLovenseを送信しました💗`,
  // 初回視聴者向け無料Lovense機能（Carinaのボタン発火用ラベル。押下回数ごとに段階的に文言を変える。
  // 送信時のチャット告知は通常の lovenseSentMessage と同じ文言を使う）
  freeLovenseButtonLabel: (args: { press: number | string }) => {
    const press = Number(args.press);
    if (press >= 3) return "イカせるチャンス！";
    if (press === 2) return "もっと気持ちよくさせよう";
    return "タップして気持ちよくさせよう";
  },
  // Carinaのボタン上部に出す吹き出し文言（残り発火可能回数を添える）
  freeLovenseCallout: (args: { count: string | number }) =>
    `無料遠隔バイブチャンス あと${args.count}回`,
  // ライブ一覧カードで無料Lovense対象（待機中+Lovense対応）の配信者に表示するタグ
  freeLovenseTag: "無料で遠隔バイブ体験",
  presentSentMessage: (args: { text: string | number }) =>
    `「${args.text}」のチップを送信しました！🎁`,
  presentSendError: "おねだりを送信できませんでした",
  // 簡易おねだりメニュー（LiveOnedariQuickMenu）連打時の節目コンボ演出
  onedariCombo: (args: { count: string | number }) => `×${args.count} COMBO!`,
  chargeTitle: "ポイントをチャージ",
  chargeDoneTitle: "チャージ完了！",
  chargeDoneDesc: (args: { point: string | number }) =>
    `${args.point}ptを獲得しました`,
  insufficientPointTitle: "ポイントが不足しています",
  insufficientPointDescription:
    "ライブを視聴するにはポイントが必要です。ポイントを購入してください。",
  pointWarning: (args: { minutes: string | number }) =>
    `残り${args.minutes}分でポイントが不足します`,
  lovenseOfflineError:
    "相手のLovenseがオフライン状態のため送信できませんでした。",
  lovenseSendError:
    "Lovenseの送信に失敗しました。時間をおいて再度お試しください。",
  lovenseActive: "実行中",
  lovenseControlling: "コントロール中",
  lovenseRemaining: (args: { seconds: string | number }) =>
    `残り${args.seconds}秒`,
  lovenseIntensity: (args: { intensity: string | number }) =>
    `強度 ${args.intensity}/20`,
  lovenseFullControlMenu: "完全コントロールメニュー",
  lovenseHide: "非表示",
  lovenseTypes: {
    // BE displayName（完全コントロール）に合わせる。メニュー由来 type("full_control") で
    // 引いたときと、ログ由来 type("完全コントロール") のフォールバック表示を一致させる。
    full_control: "完全コントロール",
  },
  insufficientPointToast: "ポイント不足により視聴が終了しました",
  pointWillRunOutToast: "残り1分で視聴が終了します",
  openProfile: "配信者のプロフィールを表示",
  mute: "ミュート",
  unmute: "ミュート解除",
  leaveConfirm: {
    title: "視聴を終了しますか？",
    confirm: "終了する",
  },
  entryCountdown: {
    badge: "まもなく入室します",
    description: "自動で配信に入室します",
    cancel: "キャンセル",
  },
  // おねだり連打の達成度に応じてコラボグッズが解禁されるイベントゲージ（無料視聴画面）の文言
  prizeGauge: {
    title: "視聴者全体の消費pt",
    myContribution: "自分の貢献",
    targetSuffix: (args: { target: string | number }) => `/ ${args.target}pt`,
    hide: "非表示",
    reopen: "進捗を表示",
    milestoneAchieved: (args: { point: string | number }) =>
      `${args.point}pt 達成`,
    helpAriaLabel: "消費ptの説明",
    helpTitle: "🎁 おねだりゲームとは？",
    helpClose: "閉じる",
    // 節目・目標達成セレブレーション（フルスクリーン演出）の文言
    celebrationMilestoneLabel: "MILESTONE",
    celebrationCongratulationsLabel: "CONGRATULATIONS",
    celebrationAchievedTitle: (args: { point: string | number }) =>
      `${args.point}pt 達成!`,
    celebrationFinalAchievedTitle: (args: { point: string | number }) =>
      `${args.point}pt 達成!!`,
    celebrationPrizeUnlocked: "プレゼント解放!",
    celebrationRewardGetLabel: "REWARD GET",
    celebrationNextMilestone: (args: {
      point: string | number;
      rewardName: string;
    }) => `次は ${args.point}pt で「${args.rewardName}」`,
    celebrationFinalThanks: "たくさんの応援ありがとう 💖",
    celebrationCloseAriaLabel: "演出を閉じる",
  },
  // 無料配信者がいるときだけ一覧最上部に出す「深田えいみコラボ」ヒーロー枠の文言
  freeWatchingFeatured: {
    collabTitle: "深田えいみコラボ", // 上部中央タイトル
    completelyFree: "完全無料", // カード内 💛 バッジ
    tonightLimited: "今夜限定", // カード内 🌙 バッジ
    specialGuest: "スペシャルゲスト配信中",
    watchFree: "無料で見る",
    note: "今夜限定の女性配信者が来てます！今だけポイント消費なし",
  },
  // 深田えいみキャンペーン期間中だけ一覧最上部に出すカウントダウンバナーの文言
  eimiCountdown: {
    badge: "LIVE予告",
    // 配信中はカウントダウン予告ではなく実況中を示す文言に切り替える
    liveBadge: "LIVE中",
    performerName: "深田えいみ",
    // performerName は別 span で太字表示するため、こちらは接尾辞のみ
    // アプリ名（Carina/Renka/Sakura等）は applicationId によって変わるため引数で受け取る
    // EimiCountdownBanner / BoardEimiCountdownLabel で使用中のため残置
    arrivalSuffix: (args: { appName: string | number }) =>
      `が${args.appName}にやってくる！`,
    // EimiCountdownTicker: 演者名・アプリ名を別 span で個別に強調表示するため分割して持つ
    arrivalParticle: "が",
    arrivalTail: "にやってくる！",
    // 簡易ラベル用: 「深田えいみの配信まであと8日と08:07:01」の「の配信まで」部分
    untilBroadcastSuffix: "の配信まで",
    liveNowCta: "配信中！今すぐ視聴 ▶",
    // 掲示板の全幅バー用: 本文とCTAチップを分けて表示するため liveNowCta とは別に持つ
    liveNowSuffix: "無料限定Live配信中！",
    watchCta: "今すぐ無料視聴 ▶",
    remainingPrefix: "あと",
    daySuffix: "日",
    dayConnector: "と",
  },
  // 限定配信者(無料視聴)向け VIP プロフィール画面（デザイン: VIPプロフィール案 1a イマーシブ・ストーリー）
  // 「LIVE」「待機中」は TEXT.live.live / TEXT.live.standby を流用する（重複追加しない）
  vipProfile: {
    marquee: (args: { name: string | number }) =>
      `✦ 今夜限り ${args.name}登場 20時からLive配信にて生着替え`,
    presentBadgeWear: (args: { name: string | number }) =>
      `${args.name}着用水着`,
    presentBadgeGift: "プレゼント",
    presentBadgeChance: "CHANCE",
    presentHelpAriaLabel: "プレゼントCHANCEの説明を見る",
    presentHelpTitle: "プレゼントCHANCEとは？",
    presentHelpClose: "閉じる",
    broadcasting: "配信中",
    selfIntro: "自己紹介",
    review: "レビュー",
    seeAll: "すべて見る ›",
    noReviews: "まだレビューはありません",
    lovenseTag: "Lovense対応",
    enter: "入室する",
    free: "完全無料",
    notFound: "この配信は見つかりませんでした",
  },
} as const;
